import _ from "lodash";
import { Broadcast } from "encharge-domain/definitions/Broadcast";

/**
 * Every email a broadcast actually sends, control first.
 *
 * Two things make this less obvious than it looks.
 *
 * Only a variant of type "email" has an email of its own. An "emailDetails"
 * variant swaps the subject or the sender and reuses the control's body, so it
 * has no emailId field at all and nothing separate to collect.
 *
 * And the variants outlive the toggle. Turning A/B off leaves the configured
 * variants in place (the defaults helper keeps `config?.variants || []`), while
 * the server falls back to sending the control alone. So the enabled flag has
 * to be checked, not just the presence of variants, or this reports emails the
 * broadcast never sent. BroadcastMetricsDisplay already reads them this way.
 */
export const broadcastEmailIds = (
  broadcast: Pick<Broadcast, "emailId" | "abTest">
): number[] => {
  const control = broadcast.emailId;
  if (!broadcast.abTest?.enabled) {
    return _.compact([control]);
  }
  const fromVariants = (broadcast.abTest.variants || []).map((variant) =>
    variant.type === "email" ? variant.emailId : undefined
  );
  return _.uniq(_.compact([control, ...fromVariants]));
};
